export default __webpack_public_path__ + "static/media/live_banner_mobile.8d109e4e.png";